/**
 * Configuration centralisée des URLs API
 */
import { getApiOrigin } from '../utils/apiOrigin';

const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
const isProduction = import.meta.env.PROD || import.meta.env.MODE === 'production';

const getApiUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  if (isProduction) {
    return 'https://api.clickorico.fr/api';
  }
  // Dev : requêtes same-origin → proxy Vite → Docker :3001
  return '/api';
};

/** URL Socket.IO (dev : même origine que Vite via proxy /socket.io) */
export const getWebSocketBaseUrl = () => {
  if (import.meta.env.VITE_WS_URL) {
    return import.meta.env.VITE_WS_URL;
  }
  if (isProduction) {
    const api = import.meta.env.VITE_API_URL || 'https://api.clickorico.fr/api';
    return getApiOrigin(api) || 'https://api.clickorico.fr';
  }
  // Dev : même origine (proxy Vite) — jamais de :3001 hardcodé (évite fuite dans le bundle prod)
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
};

export const API_CONFIG = {
  BASE_URL: getApiUrl(),
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
};

export const API_BASE_URL = API_CONFIG.BASE_URL;

console.log('🌐 [API Config] Environment:', isDevelopment ? 'DEVELOPMENT' : 'PRODUCTION');
console.log('🌐 [API Config] Base URL:', API_CONFIG.BASE_URL);
console.log('🌐 [API Config] WebSocket:', getWebSocketBaseUrl());

export default API_CONFIG;
